export const ASSETS_PATH = 'assets/dashboard';
